import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { PreviewOffer } from '../../../../../core/models/offers.model';
import { OffersService } from '../../../../../domain/services/offers.service';

@Component({
  selector: 'home-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit, OnChanges {
  @Input() offerSelected: string;
  @Input() amount: string;
  @Input() previewOffer: PreviewOffer;
  @Input() isDisabledButton: boolean = false;
  @Output() selectOfferId$ = new EventEmitter<string>();
  @Output() killPurchaseEvent = new EventEmitter<boolean>();

  public totalCostWithTaxes: string;
  public totalCostWithTaxesInstallment: string;
  public totalToPay: number;
  public CONST = CONST;

  constructor(private _offersService: OffersService) {}

  ngOnInit(): void {
    this._setTotalCosts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._setTotalCosts();
  }

  private _setTotalCosts() {
    this.totalCostWithTaxes = this._offersService.setTotalCostWithTaxes(
      this.previewOffer?.details.total_costs,
      this.previewOffer?.details.total_taxes
    );
    const installments: number = this.previewOffer?.installments.length;
    this.totalCostWithTaxesInstallment = this._offersService.setTotalCostWithTaxesInstallment(
      this.previewOffer?.details.total_costs,
      this.previewOffer?.details.total_taxes,
      installments
    );
    this.totalToPay = Number(this.totalCostWithTaxes) + Number(this.amount);
  }

  public onSelectOfferId(offerId: string) {
    if (this.isDisabledButton) return;
    this.selectOfferId$.emit(offerId);
  }

  public onKillPurchase() {
    this.killPurchaseEvent.emit(true);
  }
}
